<template>
  <div>
    <el-dialog
      :title="this.isCreated ?'新增活动开关':'编辑活动开关'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
    <el-form ref="form" :model="form" label-width="150px" size="mini" style="width:550px">
        <el-form-item label="活动" prop="key">
          <el-input v-model="form.key" :disabled="this.isCreated ?false:true"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width:130px">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自动解禁时间">
          <el-date-picker v-model="form.deadline" type="datetime"  :clearable="false"  placeholder="选择日期" format="yyyy-MM-dd HH:mm"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="settingActivityInOnline()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {},
      isCreated: false,
      statusOptions: [
        {
          value: 1,
          label: "禁止启动",
        },
        {
          value: 0,
          label: "允许启动",
        }
      ],
    };
  },

  created() {
    if(this.value.info != null){
      this.form = this.value.info
    }
    
    this.isCreated = this.value.isCreated
  },
  props: {
    value: Object,
  },
  components: {
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async settingActivityInOnline() {
      try {
        // 弹确认框
        await this.$confirm(`确认${this.isCreated?'新增':'编辑'}活动开关“${this.form.key}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/settingActivitySwitch`,
            {
              activitySwitch:this.form
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },

    ms2ymdhm(ts) {
    return util.ms2ymdhm(ts);
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

